import { IconWrapper } from '@framework/ui/components/icon/IconWrapper.tsx';
import { Button, message, Tooltip } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { FaCheckDouble } from 'react-icons/fa';
import { useSetAllReadNotifications } from './useSetAllReadNotifications.tsx';

interface IButtonNotificationReadAllProps {
  hasNotificationsToRead: boolean;
}

export const ButtonNotificationReadAll = (
  props: IButtonNotificationReadAllProps,
) => {
  const { hasNotificationsToRead = false } = props;
  const readFn = useSetAllReadNotifications();
  const { t } = useTranslation();

  const handleClick = useCallback(async () => {
    if (!readFn) return;
    try {
      await readFn.mutateAsync();
    } catch (e) {
      // biome-ignore format: <tbd>
      console.error(`[ButtonNotificationRead] Error durante la lettura della notifica.`, {error: e});
      message.error(
        t('notification.error', 'Si è verificato un errore, riprovare.'),
      );
    }
  }, [readFn, t]);

  const markAllAsReadText = t(
    'notifiche.segna-tutte-come-lette',
    'Segna tutte come lette',
  );

  const alreadyReadAllText = t(
    'notifiche.nessuna-notifica-da-leggere',
    'Nessuna notifica da leggere',
  );

  if (!readFn) return null;
  return (
    <Tooltip
      title={hasNotificationsToRead ? markAllAsReadText : alreadyReadAllText}
    >
      <Button
        disabled={!hasNotificationsToRead}
        size="small"
        type="primary"
        ghost
        onClick={() => {
          handleClick();
        }}
      >
        <IconWrapper icon={<FaCheckDouble aria-hidden="true" />} />
      </Button>
    </Tooltip>
  );
};
